import React from 'react';
import '@atlaskit/css-reset';
import { DocumentTitle } from '@atlassian/jira-global-document-title';
import { useIntl } from '@atlassian/jira-intl';
import { FinancialYearDatesSettingsPage } from '@atlassian/jira-portfolio-3-financial-year-dates';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { SettingsContainer } from '../../../common/ui/settings';
import messages from './messages';

export const ArjSettingsFinancialYear = () => {
	const { formatMessage } = useIntl();
	return (
		<UFOSegment name="plan-global-settings-financial-year-app">
			<SettingsContainer>
				<SubProductUpdater subProduct="software" />
				<DocumentTitle
					title={`${formatMessage(messages.pageTitle)} - ${formatMessage(messages.plans)}`}
				/>
				<FinancialYearDatesSettingsPage />
			</SettingsContainer>
		</UFOSegment>
	);
};
